<h3 *ngIf="data == null" mat-dialog-title>Cadastrar Tipo de Operação</h3>
<h3 *ngIf="data != null" mat-dialog-title>Alterar Tipo de Operação</h3>
<div mat-dialog-content>

    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field 
                style="width: 100%" 
                appearance="outline" 
                fxFlex="100" 
                floatLabel="always"
            >
                <mat-label>Nome</mat-label>
                <input 
                    matInput 
                    placeholder="Nome" 
                    [formControl]="nome" 
                    required
                    maxlength="255">
                <mat-error *ngIf="nome.invalid">{{getErrorNameMessage()}}</mat-error>
            </mat-form-field>
        </div>
    </div>

    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field 
                style="width: 100%" 
                appearance="outline" 
                fxFlex="100" 
                floatLabel="always"
            >
                <mat-label>Receita Estimada</mat-label>
                <input 
                    matInput 
                    placeholder="Receita Estimada" 
                    [formControl]="vlr_receita_estimada" 
                    required
                    maxlength="10"
                    currencyMask 
                    [options]="{  suffix: ' %', prefix: '', thousands: '.', decimal: ',' }">                
            </mat-form-field>
        </div>
    </div>

    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field 
                style="width: 100%" 
                appearance="outline" 
                fxFlex="100" 
                floatLabel="always"
            >
                <mat-label>Valor Mínimo Boleta</mat-label>
                <input 
                    matInput 
                    placeholder="Valor Mínimo Boleta" 
                    [formControl]="vlr_minimo_boleta" 
                    required
                    maxlength="10"
                    currencyMask 
                    [options]="{  suffix: '', prefix: 'R$ ', thousands: '.', decimal: ',' }">                
            </mat-form-field>
        </div>
    </div>

</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
    <button mat-button [disabled]="isInvalidForm()" (click)="salvar()" tabindex="-1">Salvar</button>
</div>